import tvApi from '@/api/service/tv.service';
import TakeAway from '@/models/takeAway';
import { TakeAwayProps } from '@/interfaces/models/takeAway';
import { RootState } from '@/store';
import { ActionTree, GetterTree, MutationTree, ActionContext } from 'vuex/types';

type TvState = {
  isActualOrdersFetching: boolean,
  isActualOrdersWasFetch: boolean,
  actualOrders: TakeAway[],
};

const namespaced: boolean = true;

const state: TvState = {
  isActualOrdersFetching: false,
  isActualOrdersWasFetch: false,
  actualOrders: [],
};

const getters: GetterTree<TvState, RootState> = {};

const actions: ActionTree<TvState, RootState> = {
  async fetchActualOrders({ commit }: ActionContext<TvState, RootState>, placeId: string) {
    if (!state.isActualOrdersWasFetch) {
      commit('setIsActualOrdersFetching', true);

      return tvApi.getActualOrdersByPlaceId(placeId)
        .then((orders: TakeAway[]) => {
          commit('setActualOrders', orders);
          commit('setIsActualOrdersWasFetch', true);
          commit('setIsActualOrdersFetching', false);
        });
    }
  }
};

const mutations: MutationTree<TvState> = {
  setActualOrders(state: TvState, orders: TakeAway[]) {
    state.actualOrders = orders;
  },
  addActualOrder(state: TvState, takeAwayProps: TakeAwayProps) {
    const order = state.actualOrders.find(({ id }: TakeAway): boolean => id === takeAwayProps.id);

    if (order === undefined) {
      state.actualOrders.push(TakeAway.createFromRequest(takeAwayProps));
    }
  },
  doneActualOrder(state: TvState, orderId: string) {
    const order: TakeAway | undefined = state.actualOrders.find(({ id }: TakeAway) => id === orderId);

    if (order !== undefined) {
      order.done();
    }
  },
  undoneActualOrder(state: TvState, orderId: string) {
    const order: TakeAway | undefined = state.actualOrders.find(({ id }: TakeAway) => id === orderId);

    if (order !== undefined) {
      order.undone();
    }
  },
  removeActualOrder(state: TvState, orderId: string) {
    const orderIndex = state.actualOrders.findIndex(({ id }: TakeAway) => id === orderId);

    if (orderIndex !== -1) {
      state.actualOrders.splice(orderIndex, 1);
    }
  },
  setIsActualOrdersFetching(state: TvState, isActualOrdersFetching: boolean) {
    state.isActualOrdersFetching = isActualOrdersFetching;
  },
  setIsActualOrdersWasFetch(state: TvState, isActualOrdersWasFetch: boolean) {
    state.isActualOrdersWasFetch = isActualOrdersWasFetch;
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
